var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "my-container" } },
    [
      _c(
        "b-nav-item",
        {
          directives: [
            {
              name: "b-modal",
              rawName: "v-b-modal.modal-calculator",
              modifiers: { "modal-calculator": true },
            },
          ],
          staticClass: "mr-1 cursor-pointer",
        },
        [
          _c(
            "svg",
            {
              attrs: {
                id: "Layer_1",
                fill: "currentColor",
                height: "21",
                viewBox: "0 0 24 24",
                width: "21",
                xmlns: "http://www.w3.org/2000/svg",
                "data-name": "Layer 1",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "m18 24h-12a5.006 5.006 0 0 1 -5-5v-14a5.006 5.006 0 0 1 5-5h12a5.006 5.006 0 0 1 5 5v14a5.006 5.006 0 0 1 -5 5zm-12-22a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-14a3 3 0 0 0 -3-3zm10 8h-8a3 3 0 0 1 0-6h8a3 3 0 0 1 0 6zm-8-4a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2zm-2 7a1 1 0 1 0 1 1 1 1 0 0 0 -1-1zm4 0a1 1 0 1 0 1 1 1 1 0 0 0 -1-1zm4 0a1 1 0 1 0 1 1 1 1 0 0 0 -1-1zm-8 4a1 1 0 1 0 1 1 1 1 0 0 0 -1-1zm4 0a1 1 0 1 0 1 1 1 1 0 0 0 -1-1zm8-4a1 1 0 1 0 1 1 1 1 0 0 0 -1-1zm1 5a1 1 0 0 0 -1-1h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 1-1z",
                },
              }),
            ]
          ),
        ]
      ),
      _c(
        "b-modal",
        { attrs: { id: "modal-calculator", "hide-footer": "", centered: "" } },
        [
          _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "rounded m-1 px-1 py-2 border text-right lead font-weight-bold",
                attrs: { id: "calc-display" },
              },
              [_vm._v(" " + _vm._s(_vm.calculatorValue || 0) + " ")]
            ),
            _c(
              "div",
              { staticClass: "row no-gutters" },
              _vm._l(_vm.calculatorElements, function (n) {
                return _c("div", { key: n, staticClass: "col-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "lead text-center m-1 py-1 border rounded hover-class",
                      class: {
                        "bg-success": [
                          "C",
                          "*",
                          "/",
                          "-",
                          "+",
                          "%",
                          "=",
                        ].includes(n),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.action(n)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(n) + " ")]
                  ),
                ])
              }),
              0
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }